import { useLocation } from "react-router-dom";
import { STYLE_CONTAINER, STYLE_SPACE_Y } from "../../utils/useStyle";

const Container = ({ children, style = STYLE_CONTAINER, padding = "" }) => {
  const location = useLocation();
  const isBasket = location.pathname === "/Basket";
  return (
    <div className={`${isBasket ? STYLE_SPACE_Y : ``} ${style} ${padding} `}>
      {children}
    </div>
  );
};

export default Container;
